import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/api/user/user.service';
import { SnackBarService } from 'src/app/core/services/snackbar/snackbar.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';

@Component({
  selector: 'app-system-settings',
  templateUrl: './system-settings.component.html',
  styleUrls: ['./system-settings.component.scss'],
})
/**
 * System Settings Component with tabs :)
 */
export class SystemSettingsComponent implements OnInit {
  currentActiveSystemSettings: any = {};
  loading: boolean = false;
  systemSettingsHistory: any[] = [];
  page = 0;
  pageSize = 15;
  hasPendingSchedule: boolean = true;

  labels = {
    savingError: 'unexpected-error',
    successfullyCancelMsg: 'system-settings-success-cancel',
    fixedExpirationDateLabel: 'system-settings-fixed-expiration-date',
    fixedExpirationDateDescription:
      'system-settings-fixed-expiration-date-description',
    currentRuleTitle: 'system-settings-page.current-rule-title',
    monthPrefix: 'system-settings-page.months-prefix',
    updateBtn: 'system-settings-page.update-button',
  };

  tableHeaderLabels = {
    tablePeriod: 'system-settings-page.table-period',
    tableSchedule: 'system-settings-page.table-schedule',
    tableUpdatedBy: 'system-settings-page.table-updated-by',
    tableUpdateDate: 'system-settings-page.table-update-date',
    tableStatus: 'system-settings-page.table-status',
    tableActions: 'system-settings-page.table-actions',
  };

  confirmDeleteScheduleData = {
    content: 'system-settings-page.delete-data-content',
    failButtonText: 'system-settings-page.delete-data-fail-button',
    deleteButtonText: 'system-settings-page.delete-data-delete-button',
    title: 'system-settings-page.delete-data-title',
  };

  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    private readonly userService: UserService,
    public dialog: MatDialog,
    private readonly dialogService: DialogService,
    private readonly snackBarService: SnackBarService
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit() {
    this.translationService.translateObject(this.labels);
    this.translationService.translateObject(this.tableHeaderLabels);
    this.translationService.translateObject(this.confirmDeleteScheduleData);
    this.userService.getSystemSettings().subscribe((systemSettings: any) => {
      this.currentActiveSystemSettings = systemSettings;
    });

    this.loadSystemSettingsHistoryValues();
  }

  /**
   * controller to the scrolled page
   */
  pageControllerLoad() {
    if (this.loading) {
      return;
    }
    this.page++;
    this.loadSystemSettingsHistoryValues();
  }

  /**
   * Load System Settings History Values
   */
  loadSystemSettingsHistoryValues() {
    this.loading = true;
    const params = {
      page: this.page,
      pageSize: this.pageSize,
    };
    this.userService
      .getSystemSettingsHistory(params)
      .subscribe((systemSettingsHistory: any) => {
        this.systemSettingsHistory.push(...systemSettingsHistory);
        this.hasPendingSchedule = this.systemSettingsHistory.some(
          (item) => item.status === 'SCHEDULED'
        );
        this.loading = false;
      });
  }

  /**
   * Open Settings schedule modal
   * @param {any} _systemSettings
   */
  openScheduledModal(_systemSettings?: any) {
    if (_systemSettings && _systemSettings.status !== 'SCHEDULED') {
      return;
    }

    const data = {
      currentSettings: this.currentActiveSystemSettings,
      systemSettings: _systemSettings,
      formsDisabled: !_systemSettings && this.hasPendingSchedule,
    };
    this.dialogService.openSettingScheduleFormModal(data, () => {
      this.resetHistoryList();
      this.loadSystemSettingsHistoryValues();
    });
  }

  /**
   * Open dialog modal to confirm cancel schedule
   * @param {any} _systemSettings
   */
  openConfirmDeleteScheduledModal(_systemSettings?: any) {
    if (_systemSettings && _systemSettings.status !== 'SCHEDULED') {
      return;
    }
    this.dialogService.openDialog(
      this.confirmDeleteScheduleData,
      () => {
        this.userService
          .cancelScheduledSystemSettings(_systemSettings.id)
          .subscribe({
            next: () => {
              this.snackBarService.success(this.labels.successfullyCancelMsg);
              this.resetHistoryList();
              this.loadSystemSettingsHistoryValues();
            },
            error: (err) => {
              if (err?.error?.errorMessage) {
                this.snackBarService.error(err.error.errorMessage);
              } else {
                this.snackBarService.error(this.labels.savingError);
              }
            },
          });
      },
      undefined
    );
  }

  /**
   * Reset list
   */
  resetHistoryList() {
    this.systemSettingsHistory = [];
    this.page = 0;
    this.hasPendingSchedule = false;
  }
}
